import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dl-lsoacknowledgement-notice',
  templateUrl: './lsoacknowledgement-notice.component.html',
  styleUrls: ['./lsoacknowledgement-notice.component.scss']
})
export class LSOAcknowledgementNoticeComponent implements OnInit {

  constructor(
    public noticeDialogRef: MatDialogRef<LSOAcknowledgementNoticeComponent>
  ) { }

  ngOnInit(): void {}

  sendConfirmation(note:string){
    this.noticeDialogRef.close(note);
  }

}
